import React, {useState, useEffect} from 'react'
import {makeStyles, withStyles} from '@material-ui/core/styles'
import {
    Box,
    Button,
    Checkbox,
    TextField,
    FormControlLabel,
    Typography,
} from '@material-ui/core'
import {connect} from 'react-redux'
import {dataActions} from '../../../../../../actions'
import CircularProgress from '@material-ui/core/CircularProgress'
import {DateTimePicker, LocalizationProvider} from '@material-ui/pickers'
import enLocale from 'date-fns/locale/en-US'
import DateFnsAdapter from '@material-ui/pickers/adapter/date-fns'
import {isValid, isBefore, isFuture} from 'date-fns'
import format from 'date-fns/format'

// using hook API
const useStyles = makeStyles(theme => ({
    boundaryBox: {
        display: 'flex',
        flexDirection: 'column',
        margin: '-15px 0 15px 0',
        fontSize: '0.825rem',
        alignItems: 'flex-start',
    },
    statusBox: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    submitButton: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
        margin: theme.spacing(1, 0),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '48%',
        '&:hover': {
            boxShadow: 'none',
            backgroundColor: '#00652A',
        },
    },
    goBackButton: {
        margin: theme.spacing(1, 0),
        boxShadow: 'none',
        borderRadius: theme.shape.borderRadius,
        border: '1px solid #098447',
        color: theme.palette.primary.main,
        height: '2.625rem',
        textTransform: 'uppercase',
        width: '48%',
    },
    spinnerBox: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        padding: '0 0 40px 0',
    },
    formLabel: {
        fontSize: '0.82rem',
        wordBreak: 'break-word',
    },
}))

const GreenCheckbox = withStyles({
    root: {
        color: '#098447',
        '&$checked': {
            color: '#098447',
        },
    },
    checked: {},
})(props => <Checkbox color="default" {...props} />)

const BatchUploadRecordSwipes = props => {
    const classes = useStyles()

    const {
        token,
        fetchingSwipeValidation,
        eventoccurrence,
        clearbatchswipevalidate,
        batchswiperecord,
        handleClose,
        batchSwipeArray,
        callbackfunction,
    } = props

    const {deptId, eventId, occurId, occurTitle} = eventoccurrence
    const [confirmAction, setConfirmAction] = useState(false)
    const validCount = batchSwipeArray.length

    const [selectedStartDate, handleStartDateChange] = useState(
        new Date(eventoccurrence.dateStart)
    )

    const swipedatetimeformatvalid = isValid(selectedStartDate)
    const swipedatetimeIsFuture = swipedatetimeformatvalid
        ? isFuture(new Date(selectedStartDate))
        : false
    const swipedatetimeisBefore = swipedatetimeformatvalid
        ? isBefore(
              new Date(selectedStartDate),
              new Date(eventoccurrence.dateStart)
          )
        : false
    const startdatetimevalid =
        swipedatetimeformatvalid &&
        !swipedatetimeIsFuture &&
        !swipedatetimeisBefore
    const swipedatetimeErrorTxt = !swipedatetimeformatvalid
        ? 'Invalid Date-time'
        : swipedatetimeIsFuture
        ? 'Selected date cannot be in the future'
        : swipedatetimeisBefore
        ? 'Selected date cannot precede event start date-time'
        : ''

    const startDatetimeString = format(new Date(eventoccurrence.dateStart), [
        'MM/dd/yyyy hh:mm a',
    ])

    const handleRecordSwipe = () => {
        batchswiperecord(
            token,
            deptId,
            eventId,
            occurId,
            selectedStartDate,
            batchSwipeArray
        )
        handleClose()
    }

    useEffect(() => {
        return () => {
            clearbatchswipevalidate()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <>
            {fetchingSwipeValidation ? (
                <Box className={classes.spinnerBox}>
                    <CircularProgress
                        style={{
                            color: '#00853e',
                        }}
                        thickness={3}
                    />
                </Box>
            ) : (
                <Box className={classes.boundaryBox}>
                    <Typography
                        variant="subtitle1"
                        style={{color: '#098447', margin: '5px 0'}}
                    >
                        Step 4 of 4: Record Swipes
                    </Typography>
                    <Typography
                        align="left"
                        variant="body2"
                        style={{
                            color: '#000000',
                            //fontWeight: 600,
                            padding: '5px 0 15px 0',
                        }}
                    >
                        Active swipe period starts on {startDatetimeString}
                    </Typography>
                    <LocalizationProvider
                        dateAdapter={DateFnsAdapter}
                        locale={enLocale}
                    >
                        <DateTimePicker
                            name="startdatetime"
                            label="When were these swipes collected?"
                            renderInput={props => (
                                <TextField
                                    {...props}
                                    required
                                    variant="outlined"
                                    fullWidth
                                    margin="dense"
                                    size="small"
                                    error={!startdatetimevalid}
                                    helperText={swipedatetimeErrorTxt}
                                />
                            )}
                            autoOk={true}
                            allowKeyboardControl={true}
                            disableFuture={true}
                            inputFormat="MM/dd/yyyy hh:mm a"
                            value={selectedStartDate}
                            onChange={handleStartDateChange}
                        />
                    </LocalizationProvider>

                    <Typography
                        align="left"
                        variant="body1"
                        style={{
                            color: '#000000',
                            fontWeight: 600,
                            padding: '15px 0',
                        }}
                    >
                        Are you sure you want to record {validCount} swipes to{' '}
                        {occurTitle} ?
                    </Typography>

                    <FormControlLabel
                        control={
                            <GreenCheckbox
                                checked={confirmAction}
                                onChange={() =>
                                    setConfirmAction(!confirmAction)
                                }
                                name="confirm-action"
                                disabled={
                                    fetchingSwipeValidation ||
                                    !startdatetimevalid
                                }
                            />
                        }
                        classes={{label: classes.formLabel}}
                        label="Yes, I understand this action cannot be undone."
                    />
                    <Box className={classes.statusBox}>
                        <Button
                            variant="outlined"
                            size="small"
                            className={classes.goBackButton}
                            onClick={() =>
                                callbackfunction('Batch Upload Review Results')
                            }
                        >
                            Go Back
                        </Button>
                        <Button
                            variant="contained"
                            size="small"
                            disabled={!confirmAction || !startdatetimevalid}
                            className={classes.submitButton}
                            onClick={() => handleRecordSwipe()}
                        >
                            Record Swipes
                        </Button>
                    </Box>
                </Box>
            )}
        </>
    )
}

function mapStateToProps(state) {
    return {
        token: state.authentication.token,
        fetchingSwipeValidation: state.batchswipedata.fetchingSwipeResult,
        userName: state.authentication.displayname,
    }
}

const mapDispatchToProps = {
    batchswiperecord: (
        token,
        deptId,
        eventId,
        occurId,
        selectedStartDate,
        swipeIdArray
    ) =>
        dataActions.batchswiperecordRequest(
            token,
            deptId,
            eventId,
            occurId,
            selectedStartDate,
            swipeIdArray
        ),
    clearbatchswipevalidate: () => dataActions.batchswipevalidateClear(),
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BatchUploadRecordSwipes)
